import React,{ PureComponent} from 'react';
import './ListHome.scss';
import ListItem from '../list-item/ListItem';
import DataTips from 'common/components/data-tips/DataTips';
import immutable from 'immutable';
import utils from 'common/js/utils';

const hcol = utils.hcol;//获得hcol

export default class ListHome extends PureComponent {
	constructor(props) {
		super(props);
	}
	shouldComponentUpdate(nextProps) {
		return !(nextProps.aData === this.props.aData || immutable.is(nextProps.aData, this.props.aData));
	}

    render() {
        return (
        	<div className="m-home-box">
	        	{this.props.aData.map((value, index) =>
		        	<div className="m-home-item" key={value.get('name')}>
		        		<p className="m-home-tit">{value.get('name')}</p>
				        <ul className={"m-index-list " + (hcol==2 ? "landscape-list" : "")}>
							{value.get('livedataLs').size > 0 ? 
								value.get('livedataLs').map((liveValue, liveIndex) =>
									<ListItem  oData={liveValue} key={liveValue.get('uid')} index={liveIndex+1}  search={this.props.search} isYanzhi="false" />
								) : 
								<DataTips type="noHomeData" txt="该分类暂无主播开播"/>
							}
				        </ul>
			        </div>
		        )}
	        </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/index/list-home/ListHome.jsx